import { FormLabel } from '@gov-design-system-ce/react-form';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import type { ApplicantDetailsProps } from '@gov-nx/ui/types';
import { LayoutGap } from '@gov-nx/ui/web';
import { ApplicantDetailsName } from './ApplicantDetailsName';
import { ApplicantDetailsAddress } from './ApplicantDetailsAddress';
import { ApplicantDetailsBirthDate } from './ApplicantDetailsBirthDate';

export const ApplicantDetails = ({
	individualPerson,
	businessPerson,
	dataBoxSelect,
	values,
	title,
}: ApplicantDetailsProps) => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Component);
	const personsProps = { individualPerson, businessPerson };

	return (
		<dl>
			<LayoutGap gap="s">
				{title ? <FormLabel isLegend={true}>{title}</FormLabel> : null}
				<ApplicantDetailsName {...personsProps} />
				<ApplicantDetailsBirthDate {...personsProps} />
				<ApplicantDetailsAddress {...personsProps} />
				{dataBoxSelect && dataBoxSelect}
				{values && (
					<>
						{values.ico ? (
							<LayoutGap gap="s">
								<dt className="text-body-s">{t('zadatel.pole.udaje.ico')}</dt>
								<dd className="text-(--text-secondary)">{values.ico}</dd>
							</LayoutGap>
						) : null}
						{values._businessAddress ? (
							<LayoutGap gap="s">
								<dt className="text-body-s">
									{t('zadatel.pole.udaje.adresa-podnikani')}
								</dt>
								<dd className="text-(--text-secondary)">
									{values._businessAddress}
								</dd>
							</LayoutGap>
						) : null}
					</>
				)}
			</LayoutGap>
		</dl>
	);
};
